// client/src/lib/feeDrag.ts
//
// Fee-drag maths shared by FeeGapCard and the adviser cost guide (#454): a lump
// sum growing at a fixed rate before charges, with a yearly percentage charge
// taken off the growth rate. Illustrative only: no contributions, no tax.

/** Value of `principal` after `years` at `growth` a year less `charge` a year (both decimals). */
export function potAfterCharges(principal: number, growth: number, charge: number, years: number): number {
  return principal * Math.pow(1 + growth - charge, years);
}

/** How much less you end up with paying `higherCharge` instead of `lowerCharge`. */
export function feeGap(principal: number, growth: number, lowerCharge: number, higherCharge: number, years: number): number {
  return potAfterCharges(principal, growth, lowerCharge, years) - potAfterCharges(principal, growth, higherCharge, years);
}

/**
 * Element id of the fee-gap calculator (FeeGapCard), for in-page links to it.
 * Lives here rather than in FeeGapCard because that is a client module: a
 * server component importing a constant from it gets a client reference, not
 * the string, and the link breaks.
 */
export const FEE_GAP_ANCHOR = 'what-charges-cost';
